export const SetFormLogin = (email, password) => ({
  type: "SET_FORM_INPUT",
  data: { email, password },
});

export const SetEmailLoginError = (form1, form1Message) => ({
  type: "OPEN_FORM_EMAIL_ERROR",
  data: { form1, form1Message },
});

export const SetPasswordLoginError = (form2, form2Message) => ({
  type: "OPEN_FORM_PASSWORD_ERROR",
  data: { form2, form2Message },
});

export const onLogout = () => ({
  type: "RESET_APP",
});
